import React from "react";
import TopBar from "../navigation/TopBar";
import Sidebar from "../ui/Sidebar";

interface AdminLayoutProps {
	children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
	return (
		<div className="min-h-screen bg-background">
			{/* Sidebar - Admin only */}
			<Sidebar />

			{/* Main Content Area */}
			<div className="lg:pl-60">
				{/* Top Bar */}
				<TopBar />

				{/* Page Content */}
				<main className="pt-16 lg:pt-20 min-h-screen">{children}</main>
			</div>
		</div>
	);
};

export default AdminLayout;
